import { EmailerSendersGETResponse } from '../backend/EmailerSendersGETResponse';

export type Sender = EmailerSendersGETResponse[0];

export enum SenderType {
  DOMAIN = 'domain',
  EMAIL = 'email'
}

export enum DKIM_STATUS {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  TEMPORARY_FAILURE = 'TEMPORARY_FAILURE',
  NOT_STARTED = 'NOT_STARTED'
}

export enum MAIL_FROM_STATUS {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  TEMPORARY_FAILURE = 'TEMPORARY_FAILURE'
}
